module.exports = __webpack_public_path__ + "static/media/kids_13.c5561b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_13.jpg
// module id = 5869
// module chunks = 0